<template>
  <div class="special-case-step">
    <GridPanelHeader
      :title="$t('tools.special_cases.works_step_description')"
      :grid-ref="$refs.selectedWorksGrid"
      :show-add="canSelectWorks"
      :show-filter="false"
      :show-export="false"
      :show-columns="false"
      @add="openSelector"
    />
    <DxDataGrid
      ref="selectedWorksGrid"
      :data-source="selectedWorks"
      key-expr="uuid"
      :element-attr="gridAttributes"
      :show-borders="true"
      :show-column-lines="true"
      :column-auto-width="true"
      :hover-state-enabled="true"
      :repaint-changes-only="true"
      :row-alternation-enabled="true"
      @row-removing="onWorkRemoving"
    >
      <DxColumn data-field="parcel.name" :caption="$t('common.parcel')" />
      <DxColumn data-field="season.name" :caption="$t('common.season')" />
      <DxColumn data-field="culture.name" :caption="$t('common.culture')" />
      <DxColumn data-field="work_started_at" :caption="$t('common.work_date')" data-type="date" format="yyyy-MM-dd" />
      <DxColumn data-field="work.name" :caption="$t('common.work_name')" />
      <DxColumn data-field="machine.name" :caption="$t('common.tractor')" />
      <DxColumn data-field="machinery.name" :caption="$t('common.work_machine')" />
      <DxColumn data-field="person.name" :caption="$t('common.driver')" />
      <DxColumn data-field="net_surface_worked" :caption="$t('works.work_list.worked_area')" data-type="number" />
      <DxScrolling mode="standard" show-scrollbar="always" />
      <DxEditing mode="cell" :allowUpdating="false" :allowAdding="false" :allowDeleting="true" :use-icons="true">
        <DxTexts
          :confirm-delete-message="$t('common.confirm_delete', { title: $t('common.work_name') })"
          :confirm-delete-title="$t('common.confirm_delete_title')"
          :deleteRow="$t('common.delete')"
        />
      </DxEditing>
    </DxDataGrid>
    <WorkSelector
      :visible="selectorVisible"
      :title="$t('tools.special_cases.target_works')"
      :filter-data="filterData"
      :selected-work-uuids="targetUuids"
      @close="selectorVisible = false"
      @continue="onWorksSelected"
      :lock-context-filters="true"
    />
  </div>
</template>

<script>
import moment from "moment";
import { DxDataGrid, DxColumn, DxScrolling, DxEditing, DxTexts } from "devextreme-vue/data-grid";
import WorkSelector from "@/components/WorkSelector.vue";
import GridPanelHeader from "@/components/DxGrid/GridPanelHeader.vue";

export default {
  name: "SpecialCaseWorksStep",
  components: { DxDataGrid, DxColumn, DxScrolling, DxEditing, DxTexts, WorkSelector, GridPanelHeader },
  props: {
    formData: { type: Object, required: true },
    options: { type: Object, required: true },
    saving: { type: Boolean, default: false },
  },
  data() {
    return {
      gridAttributes: { class: "smagria-grid special-case-works-grid" },
      selectorVisible: false,
    };
  },
  computed: {
    targetUuids() {
      return this.formData.target_uuids || [];
    },
    selectedWorks() {
      return this.formData.target_works || [];
    },
    filterData() {
      return {
        department_uuid: this.formData.department_uuid,
        season_uuid: this.formData.season_uuid,
        work_started_at: moment(this.formData.work_started_at).isValid() ? moment(this.formData.work_started_at).format("YYYY-MM-DD") : null,
        exclude_supporting: 1,
      };
    },
    canSelectWorks() {
      return !this.saving && !!this.formData.department_uuid && !!this.formData.season_uuid;
    },
  },
  methods: {
    openSelector() {
      this.selectorVisible = true;
    },
    onWorksSelected(works) {
      const worksByUuid = new Map([...this.selectedWorks, ...(works || [])].map((work) => [work.uuid, work]));
      this.$emit("input", {
        target_uuids: Array.from(worksByUuid.keys()),
        target_works: Array.from(worksByUuid.values()).filter(Boolean),
      });

      this.selectorVisible = false;
    },
    onWorkRemoving(event) {
      event.cancel = true;
      const workUuid = event.data.uuid;
      this.$emit("input", {
        target_uuids: this.targetUuids.filter((uuid) => uuid !== workUuid),
        target_works: this.selectedWorks.filter((work) => work.uuid !== workUuid),
      });
    },
    validate() {
      return this.targetUuids.length ? [] : [this.$t("tools.special_cases.select_targets")];
    },
  },
};
</script>

<style lang="scss" scoped>
.special-case-works-grid {
  height: calc(95vh - 290px) !important;
}
</style>
